// extracted by mini-css-extract-plugin
export default {"radioContainer":"AssignTablesDialogServerList_radioContainer__yDDMk","listItem":"AssignTablesDialogServerList_listItem__Ng058"};